const generateQrCodeOptions = (data, type, options, apiUrl) => {
    const newOptions = {
        data: data || `${apiUrl}`,
        dotsOptions: { type: options.dotsType || "square" },
        backgroundOptions: { color: options.bgColor || "#ffffff" },
        imageOptions: {
            crossOrigin: "anonymous",
            margin: 5
        }
    };

    if (options.colorMode === "gradient") {
        newOptions.dotsOptions.gradient = {
            type: options.gradientType || "linear",
            colorStops: [
                { offset: 0, color: options.gradientColors[0] || "#000000" },
                { offset: 1, color: options.gradientColors[1] || "#ffffff" }
            ]
        };
    } else {
        newOptions.dotsOptions.color = options.color || "#000000";
    }

    if (options.image) {
        newOptions.image = options.image;
    } else if ((type === "url" || type === "text") && (data.includes("qrcbr") || data === "")) {
        newOptions.image = `${apiUrl}/imagens/logoqrc.png`;
    } else {
        newOptions.image = null;
    }

    return newOptions;
};

export default generateQrCodeOptions;